<template>
  <div>
    <!-- <div class="top">
      <Breadcrumb :options="breadcrumb" />
      <Wxts :wxtsList="wxtsList" />
    </div> -->

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item v-if="user && [1, 5, 7].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :allBtnWidth="200" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
// import Wxts from '../../../components/Wxts.vue';
export default {
  // components: { Wxts },
  name: "VehicleHang",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'trailer',
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/hang` },
        { name: "挂车管理", path: `/vehicle/hang` },
      ],
      wxtsList: [
        {
          name: '该处添加的挂车，可在【车辆管理】',
          path: '/vehicle/manage',
          pathName: '【车辆列表】',
          tailName: '处绑定。',
        }
      ],
      formCtrl: [
        {
          label: "挂车号",
          keyName: "pname",
          placeholder: "请填写挂车号",
          type: "text",
        },
      ],
      cols: [
        { keyName: "trailer", label: "挂车号", minwidth: 120 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "ton", label: "核定载重(吨)", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "buytime", label: "车辆购入时间", minwidth: 120 },
        // { keyName: "carstatus", label: "状态", minwidth: 120 },
      ],
      btns: [
        {
          ...this.viewBtn,
          title: "查看",
          cb: ({ id }) => {
            this.$router.push(
              `/vehicle/hangview?id=${id}`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(`/vehicle/hangdetail?mode=edit&id=${id}&fleetid=${this.formInline.fleet}&fleetName=${this.fleetName}`);
          },
        },
        {
          class: 'documentbtn',
          img: require('@/assets/img/icon_document.png'),
          unimg: require('@/assets/img/icon_document_hover.png'),
          title: '证件',
          cb: ({ id, trailer }) => {
            this.$router.push(`/vehicle/hangDocument?car_type=2&id=${id}&trailer=${trailer}`);
          },
        },
        {
          class: 'insurancebtn',
          img: require('@/assets/img/icon_insurance.png'),
          unimg: require('@/assets/img/icon_insurance_hover.png'),
          title: '保险',
          cb: ({ id, trailer }) => {
            this.$router.push(`/vehicle/hangInsurance?car_type=2&id=${id}&trailer=${trailer}`);
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      baseParams: ['carstatus'],
      list: ['在用', '停用', '报废'],
    };
  },
  methods: {
    addItem() {
      this.$router.push(`/vehicle/hangdetail`);
    },
    setParams() {
      const { status } = this.$route.params
      this.formInline.carstatus = this.list[status - 1]
      this.page = 1
      this.getList()
    },
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
      this.setParams()
    },
  },
  mounted() {
    this.setParams();
  },
};
</script>
<style lang="less" scoped>
/deep/ .dialog {
  .el-form {

    .el-input,
    .el-textarea {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}
</style>